import { useState, useEffect } from 'react'

const useScrollPosition = (YPos: number) => {
    const [isUserScrolled, setIsUserScrolled] = useState(false)
    const [isInitialScroll, setIsInitialScroll] = useState(false)

    useEffect(() => {
        const handleScroll = () => {
            const position = window.scrollY
            if (position === 0) {
                setTimeout(() => setIsInitialScroll(false), 250)
            }
            if (position > YPos) {
                setIsInitialScroll(true)
                setIsUserScrolled(true)
            } else {
                setIsUserScrolled(false)
            }
        }

        window.addEventListener('scroll', handleScroll)

        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [YPos])

    return { isUserScrolled, isInitialScroll }
}

export default useScrollPosition
